import JSX from "./helpers/react.js";

Object.defineProperties(window, {
    mobileOperatingSystem: {
        get() {
            // @ts-ignore
            const userAgent = navigator.userAgent || navigator.vendor || window['opera'];
            if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
                return 'iOS';
            } else if (userAgent.match(/Android/i)) {
                return 'Android';
            } else if (userAgent.match(/Trident/i)) {
                return 'IE';
            } else if (userAgent.match(/Edge/i)) {
                return 'Edge';
            } else if (userAgent.match(/Opera/i) || userAgent.match(/OPR/i)) {
                return 'Opera'
            }
            return 'unknown';
        }
    },
    escapeHtml: {
        value(text: string) {
            if (text) {
                return text
                    .replace(/&/g, "&amp;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;")
                    .replace(/"/g, "&quot;")
                    .replace(/'/g, "&#039;");
            }
            return '';

        },
        writable: false
    },
    linkWhiteList: {
        get() {
            return [
                window.location.hostname,
                'wikipedia.org',
                'youtube.com',
                'imgur.com',
                'youtu.be',
                'prnt.sc',
                'yummyani.meme',
                'yummyani.me',
                'yummy-anime.ru'
            ];
        }
    },
    commentsLinkWhiteList: {
        get() {
            return [
                window.location.hostname, 'wikipedia.org',
                'imgur.com',
                'prnt.sc',
                'yani.tv',
                'yummy-anime.ru',
                'yummyani.me',
                'yummyani.meme',
                'yummy-ani.me'
            ];
        }
    },
    convertTimeFull: {
        value(UNIX_timestamp: number) {
            const d = new Date(UNIX_timestamp * 1000);
            let str = '';
            str += ('0' + d.getDate()).slice(-2);
            str += '.' + ('0' + (d.getMonth() + 1)).slice(-2);
            str += '.' + d.getFullYear();
            str += ' ' + ('0' + d.getHours()).slice(-2);
            str += ':' + ('0' + d.getMinutes()).slice(-2);
            str += ':' + ('0' + d.getSeconds()).slice(-2);
            return str;
        },
        writable: false
    },
    convertTime: {
        value(UNIX_timestamp: number, needNewLine: boolean = false, onlyDate: boolean = false) {
            const d = new Date(UNIX_timestamp * 1000),
                now = new Date();

            const months = ['Янв', 'Фев', 'Мар', 'Апр', 'Мая', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'];
            let str = ('0' + d.getDate()).slice(-2);
            str += ' ' + months[d.getMonth()] + ' ';
            if (onlyDate) str = str.trim();
            else {
                if (needNewLine) str = str.trim() + "<br>";
                if (!needNewLine && now.getFullYear() !== d.getFullYear()) {
                    str += d.getFullYear();
                } else {
                    str += ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
                }
            }
            return str;
        },
        writable: false
    },
    login: {
        get() {
            return $('#login').html();
        }
    },
    user_id: {
        get() {
            return ($('#current_user_id').val() as string | undefined)?.toInt();
        }
    },
    user_nickname: {
        get() {
            return ($('#user_nickname').val() as string | undefined);
        }
    },
    slimCustom: {
        value(this: HTMLSelectElement, f: any) {
            const t = $(this),
                d: SlimSelectParams = {
                    select: this,
                    searchPlaceholder: 'Искать',
                    searchText: 'Ничего не найдено',
                    placeholder: (t.data('placeholder') || 'Поиск...'),
                    showContent: 'down',
                }
            if (window.screen.width <= 768) {
                if (this.multiple) {
                    d.allowDeselectOption = true;
                    d.closeOnSelect = false;
                }
                d.beforeOpen = function () {
                    // this.select.element.style.display = "block"
                    document.body.style.overflow = 'hidden';
                }
                d.beforeClose = function () {
                    // this.select.element.style.display = "none"
                    document.body.style.overflow = '';
                }
            }
            if (t.data('addable')) {
                d.addable = f || ((val: any) => val);
            }
            return d
        }
    },
    ratingList: {
        value: [
            'не выбрано',
            'ничтожно',
            'ужасно',
            'плохо',
            'никак',
            'посредственно',
            'неплохо',
            'хорошо',
            'очень хорошо',
            'великолепно',
            'шедевр'
        ],
        writable: false
    },
    userRoles: {
        get() {
            return JSON.parse($('#user_roles').val() as string ?? '[]');
        }
    },

    page_type: {
        get() {
            const $el = $("#page_type");
            return $el.attr('content') || $el.val();
        }
    },
    page_id: {
        get() {
            const $el = $("#page_id");

            return ($el.attr('content') || $el.val() as string | undefined)?.toInt();
        }
    },
    is_ukraine: {
        get() {
            const $el = $('#is_ukraine');
            return ($el.attr('content')) == '1';
        }
    },
    supportedImageFormats: {
        get() {
            return supportedFormats;
        }
    }
});
export const statuses = [
    {
        'title': 'вышел',
        'href': 'released',
        'class': ''
    },
    {
        'title': 'онгоинг',
        'href': 'ongoing',
        'class': ' review'
    },
    {
        'title': 'анонс',
        'href': 'announcement',
        'class': ' attention'
    }
];
export const types = ['', 'ТВ', 'п/ф', 'к/ф', 'OVA', 'Спешл', 'м/с', 'ONA']
export const typesLong = ['', 'Сериал', 'Полнометражный фильм', 'Короткометражный фильм', 'OVA', 'Спешл', 'Малометражный сериал', 'ONA'];
export const seasons = [
    "",
    'Зима',
    'Весна',
    'Лето',
    'Осень'
];
export const yearRatings = [
    {
        name: 'Не учитывать',
        shortname: 'Неизвестно',
        description: 'Не определено'
    },
    {
        name: 'G (для всех возрастов)',
        shortname: 'G',
        description: 'Для всех возрастов'
    },
    {
        name: 'PG (для детей)',
        shortname: 'PG',
        description: 'Для детей'
    },
    {
        name: 'PG-13 (от 13 лет)',
        shortname: 'PG-13',
        description: 'Допускаются дети от 13 лет'
    },
    {
        name: 'R-17+ (насилие и/или нецензурная лексика)',
        shortname: 'R-17+',
        description: 'Насилие и/или нецензурная лексика'
    },
    {
        name: 'R+ (есть сцены легкой эротики)',
        shortname: 'R+',
        description: 'Есть сцены легкой эротики'
    }
];
export const genres = [
    {
        "value": 72,
        "title": "Альтернативная история",
        "href": "al-ternativnaya-istoriya"
    },
    {
        "value": 43,
        "title": "Альтернативная реальность",
        "href": "al-ternativnaya-real-nost"
    },
    {
        "value": 44,
        "title": "Ангелы",
        "href": "angely"
    },
    {
        "value": 26,
        "title": "Андроиды",
        "href": "androidy"
    },
    {
        "value": 73,
        "title": "Антивойна",
        "href": "antivojna"
    },
    {
        "value": 74,
        "title": "Антиутопия",
        "href": "antiutopiya"
    },
    {
        "value": 92,
        "title": "Баскетбол",
        "href": "basketbol"
    },
    {
        "value": 110,
        "title": "Безумие",
        "href": "bezumie"
    },
    {
        "value": 2,
        "title": "Бисёнэн",
        "href": "bisenen",
        "moreTitles": [
            "Бисёнен"
        ]
    },
    {
        "value": 64,
        "title": "Боевые искусства",
        "href": "boevye-iskusstva"
    },
    {
        "value": 45,
        "title": "Божества",
        "href": "bogi"
    },
    {
        "value": 46,
        "title": "Вампиры",
        "href": "vampiry"
    },
    {
        "value": 47,
        "title": "Ведьмы",
        "href": "ved-my"
    },
    {
        "value": 13,
        "title": "Вестерн",
        "href": "vestern"
    },
    {
        "value": 61,
        "title": "Виртуальная реальность",
        "href": "virtual-naya-real-nost"
    },
    {
        "value": 76,
        "moreTitles": [
            "Военное",
            "военный",
            "боевик"
        ],
        "title": "Военная тематика",
        "href": "voennaya-tematika"
    },
    {
        "value": 75,
        "title": "Война",
        "href": "vojna"
    },
    {
        "value": 19,
        "title": "Воры",
        "href": "vori"
    },
    {
        "value": 77,
        "title": "Гарем",
        "href": "garem"
    },
    {
        "value": 96,
        "title": "Гарем (для девочек)",
        "href": "garem-dlya-devochek"
    },
    {
        "value": 102,
        "title": "Гендерная интрига",
        "href": "trap"
    },
    {
        "value": 48,
        "title": "Демоны",
        "href": "demony"
    },
    {
        "value": 14,
        "title": "Детектив",
        "moreTitles": [
            "детектив"
        ],
        "href": "detektiv"
    },
    {
        "value": 4,
        "title": "Дзёсэй",
        "moreTitles": [
            "Дзёсей"
        ],
        "href": "dzesej"
    },
    {
        "value": 49,
        "title": "Драконы",
        "href": "drakony"
    },
    {
        "value": 15,
        "title": "Драма",
        "moreTitles": [
            "драма"
        ],
        "href": "drama"
    },
    {
        "value": 50,
        "title": "Зомби",
        "href": "zombi"
    },
    {
        "value": 104,
        "title": "Игры",
        "href": "igry"
    },
    {
        "value": 38,
        "title": "Инопланетные расы",
        "href": "inoplanetyane"
    },
    {
        "value": 29,
        "title": "Искусственный интеллект",
        "href": "ii"
    },
    {
        "value": 78,
        "title": "Искусство",
        "href": "iskusstvo"
    },
    {
        "value": 80,
        "title": "Исторический",
        "moreTitles": [
            "история"
        ],
        "href": "istoricheskij"
    },
    {
        "value": 106,
        "title": "Исэкай",
        "href": "isekai"
    },
    {
        "value": 81,
        "title": "Киберпанк",
        "href": "kiberpank"
    },
    {
        "value": 39,
        "title": "Киборги",
        "href": "kiborgi"
    },
    {
        "value": 107,
        "title": "Китайское 3D",
        "href": "chinese3d"
    },
    {
        "value": 16,
        "title": "Комедия",
        "moreTitles": [
            "комедия"
        ],
        "href": "komediya"
    },
    {
        "value": 40,
        "title": "Космос",
        "href": "kosmicheskie-priklyucheniya"
    },
    {
        "value": 82,
        "title": "Кулинария",
        "href": "kulinariya"
    },
    {
        "value": 83,
        "title": "Лоликон",
        "href": "lolikon"
    },
    {
        "value": 34,
        "title": "Любовный треугольник",
        "href": "lyubovnyj-treugol-nik"
    },
    {
        "value": 51,
        "title": "Магия",
        "href": "magiya"
    },
    {
        "value": 99,
        "title": "Манга",
        "href": "manga"
    },
    {
        "value": 20,
        "title": "Мафия/Якудза",
        "href": "mafiya-yakudza"
    },
    {
        "value": 5,
        "title": "Махо-сёдзё",
        "href": "maho-sedze"
    },
    {
        "value": 25,
        "title": "Меха",
        "href": "meha"
    },
    {
        "value": 31,
        "title": "Мистика",
        "href": "mistika"
    },
    {
        "value": 108,
        "title": "Мотоциклы",
        "href": "motorcycles"
    },
    {
        "value": 79,
        "title": "Музыка",
        "moreTitles": [
            "музыка"
        ],
        "href": "muzyka"
    },
    {
        "value": 85,
        "title": "Нелинейный сюжет",
        "href": "nelinejnyj-syuzhet"
    },
    {
        "value": 101,
        "title": "Не японское",
        "href": "ne-yaponskoe"
    },
    {
        "value": 65,
        "title": "Ниндзя",
        "href": "nindzya"
    },
    {
        "value": 21,
        "title": "Охотники за головами",
        "href": "ohotniki-za-golovami"
    },
    {
        "value": 62,
        "title": "Параллельный мир",
        "href": "parallel-nyj-mir"
    },
    {
        "value": 17,
        "title": "Пародия",
        "href": "parodiya"
    },
    {
        "value": 66,
        "title": "Перестрелки",
        "href": "perestrelki"
    },
    {
        "value": 27,
        "title": "Пилотируемые роботы",
        "href": "pilotiruemye-roboty"
    },
    {
        "value": 22,
        "title": "Пираты",
        "href": "piraty"
    },
    {
        "value": 86,
        "title": "Повседневность",
        "href": "povsednevnost"
    },
    {
        "value": 87,
        "title": "Политика",
        "href": "politika"
    },
    {
        "value": 88,
        "title": "Полицейские",
        "moreTitles": [
            "Полиция"
        ],
        "href": "policejskie"
    },
    {
        "value": 97,
        "title": "Полулюди",
        "href": "lyudi-zveri"
    },
    {
        "value": 89,
        "title": "Постапокалиптика",
        "href": "postapokaliptika"
    },
    {
        "value": 18,
        "title": "Преступный мир",
        "href": "prestupnyj-mir"
    },
    {
        "value": 52,
        "title": "Призраки",
        "href": "prizraki"
    },
    {
        "value": 32,
        "title": "Приключения",
        "moreTitles": [
            "приключения"
        ],
        "href": "priklyucheniya"
    },
    {
        "value": 67,
        "title": "Прокси бои",
        "href": "proksi-boi"
    },
    {
        "value": 98,
        "title": "Психология",
        "moreTitles": [
            "Психологическое"
        ],
        "href": "psihologiya"
    },
    {
        "value": 41,
        "title": "Путешествия во времени",
        "href": "puteshestviya-vo-vremeni"
    },
    {
        "value": 33,
        "title": "Романтика",
        "href": "romantika"
    },
    {
        "value": 53,
        "title": "Русалки",
        "href": "rysalki"
    },
    {
        "value": 90,
        "title": "Русские в аниме",
        "href": "rossiya-v-anime"
    },
    {
        "value": 68,
        "title": "Самураи",
        "href": "samurai"
    },
    {
        "value": 103,
        "title": "Сверхъестественное",
        "href": "sverh-estestvennoe"
    },
    {
        "value": 6,
        "title": "Сёдзё",
        "href": "sedze",
        "moreTitles": [
            "Сёдзе"
        ]
    },
    {
        "value": 7,
        "title": "Сёдзё-ай",
        "href": "sedze-aj",
        "moreTitles": [
            "Сёдзе-ай",
            "Юри"
        ]
    },
    {
        "value": 8,
        "title": "Сёнэн",
        "moreTitles": [
            "Сёнен"
        ],
        "href": "senen"
    },
    {
        "value": 9,
        "title": "Сёнэн-ай",
        "moreTitles": [
            "Сёнен-ай",
            "Яой"
        ],
        "href": "senen-aj"
    },
    {
        "value": 28,
        "title": "Силовые костюмы",
        "href": "silovye-kostyumy"
    },
    {
        "value": 54,
        "title": "Современное фэнтези",
        "href": "sovremennoe-fentezi"
    },
    {
        "value": 91,
        "title": "Спорт",
        "href": "sport"
    },
    {
        "value": 69,
        "title": "Сражения на мечах",
        "href": "srazheniya-na-mechah"
    },
    {
        "value": 93,
        "title": "Стимпанк",
        "href": "stimpank"
    },
    {
        "value": 55,
        "title": "Суккубы",
        "href": "sukkuby"
    },
    {
        "value": 70,
        "title": "Суперспособности",
        "moreTitles": [
            "Супер сила"
        ],
        "href": "supersposobnosti"
    },
    {
        "value": 10,
        "title": "Сэйнэн",
        "href": "sejnen",
        "moreTitles": [
            "Сэйнён",
            "Сейнен",
            "Сейнэн"
        ]
    },
    {
        "value": 94,
        "title": "Тайный заговор",
        "href": "tajnyj-zagovor"
    },
    {
        "value": 56,
        "title": "Темное фэнтези",
        "href": "temnoe-fentezi"
    },
    {
        "value": 57,
        "title": "Темные эльфы",
        "href": "temnye-el-fy"
    },
    {
        "value": 23,
        "title": "Террористы",
        "href": "terroristy"
    },
    {
        "value": 30,
        "title": "Трансформеры",
        "href": "transformery"
    },
    {
        "value": 35,
        "title": "Триллер",
        "href": "triller"
    },
    {
        "value": 24,
        "title": "Убийцы",
        "href": "ubijcy"
    },
    {
        "value": 36,
        "title": "Ужасы",
        "href": "ugasy"
    },
    {
        "value": 37,
        "title": "Фантастика",
        "moreTitles": [
            "фантастика"
        ],
        "href": "fantastika"
    },
    {
        "value": 58,
        "title": "Феи",
        "href": "fei"
    },
    {
        "value": 42,
        "title": "Фэнтези",
        "moreTitles": [
            "фэнтези"
        ],
        "href": "fentezi"
    },
    {
        "value": 109,
        "title": "Хулиганы",
        "href": "badguys"
    },
    {
        "value": 59,
        "title": "Целый фэнтези мир",
        "href": "celyj-fentezi-mir"
    },
    {
        "value": 95,
        "title": "Школьная жизнь",
        "moreTitles": [
            "Школа"
        ],
        "href": "shkola"
    },
    {
        "value": 63,
        "title": "Экшен",
        "href": "ekshen"
    },
    {
        "value": 60,
        "title": "Эльфы",
        "href": "el-fy"
    },
    {
        "value": 100,
        "title": "Эротика",
        "href": "erotica",
        "moreTitles": [
            "Хентай"
        ]
    },
    {
        "value": 11,
        "title": "Этти",
        "href": "etti"
    }
] as const;
export const favoriteTypes = [
    {
        "title": "Смотрю",
        "href": "watch_now",
        "class": "watch-now",
        "id": 0,
        "icon": "fa-eye",
        color: 'var(--main-red)'
    },
    {
        "title": "В Планах",
        "href": "will",
        "class": "position",
        "id": 1,
        "icon": "fa-cloud",
        color: 'var(--main-purple)'
    },
    {
        "title": "Просмотрено",
        "href": "watched",
        "class": "saw",
        "id": 2,
        "icon": "fa-flag-checkered",
        color: 'var(--main-green)'

    },
    {
        'title': 'Отложено',
        'href': 'postpone',
        'class': 'postpone',
        'id': 5,
        "icon": "fa-history",
        color: 'var(--main-yellow)'

    },
    {
        "title": "Брошено",
        "href": "lost",
        "class": "lost",
        "id": 3,
        "icon": "fa-eye-slash",
        color: 'var(--border-third)'

    },
    {
        "title": "Любимые",
        "href": "favourite",
        "class": "favorite",
        "id": 4,
        "icon": "fa-heart",
        color: 'var(--border-pink)'
    },

] as const;
export const posterSizes = '(max-width: 415px) calc(50vw - 20px), (max-width: 490px) 280px, (max-width: 720px) calc(50vw - 30px), (max-width: 950px) calc(33vw - 20px), (max-width: 1256px) calc(25vw - 20px), 230px';
export const userPermissions: { [k: string]: string } = {
    editor: 'Редактор',
    supereditor: 'Редактор+',
    admin: 'Администратор',
    root: 'Владелец',
    chatadmin: 'Модератор',
    videoblogger: 'Партнёр',
    reviewer: 'Рецензент',
    newsroom: 'Новостник'
};

let supportedFormats: { webp?: boolean, avif?: boolean } = {};

export async function getAcceptHeader() {
    const ans = ['application/json'];
    while (supportedFormats.webp === undefined) await new Promise(r => setTimeout(r, 10));
    while (supportedFormats.avif === undefined) await new Promise(r => setTimeout(r, 10));
    if (supportedFormats.webp) ans.push('image/webp');
    if (supportedFormats.avif) ans.push('image/avif');
    return ans.join(',');
}

String.prototype.toInt = function (): number {
    return +this;
}
{
    //Check if formats supported
    function checkImageSupported(imgBase64: string) {
        const img = document.createElement('img');
        return new Promise((resolve, reject) => {
            img.onload = resolve;
            img.onerror = reject;
            img.src = imgBase64;
        });
    }

    checkImageSupported('data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUEAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABYAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgSAAAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB5tZGF0EgAKBzgADlAgIGkyCR/wAABAAACvcA==')
        .then(() => void (supportedFormats.avif = true))
        .catch((e) => {
            console.warn("Avif images format is not supported")
            supportedFormats.avif = false;
        });
    checkImageSupported('data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=')
        .then(() => void (supportedFormats.webp = true))
        .catch(() => {
            console.warn("Webp images format is not supported. This may case some problems with compatibility")
            supportedFormats.webp = false;
        });
}
{
    HTMLImageElement.prototype.toDataUrl = function (this: HTMLImageElement, format: string = 'image/png'): Promise<string> {
        return new Promise(r => {
            const canvas: HTMLCanvasElement = document.createElement('CANVAS') as HTMLCanvasElement;
            const ctx = canvas.getContext('2d')!;
            let dataURL;
            canvas.height = this.naturalHeight;
            canvas.width = this.naturalWidth;
            ctx.drawImage(this, 0, 0);
            dataURL = canvas.toDataURL(format);
            r(dataURL);
        });
    }
}

export {};